/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Category_BugInputs */

const en_feedback_category_bug = /** @type {(inputs: Feedback_Category_BugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bug Report`)
};

const de_feedback_category_bug = /** @type {(inputs: Feedback_Category_BugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlerbericht`)
};

const fr_feedback_category_bug = /** @type {(inputs: Feedback_Category_BugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapport de bug`)
};

const es_feedback_category_bug = /** @type {(inputs: Feedback_Category_BugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe de error`)
};

const it_feedback_category_bug = /** @type {(inputs: Feedback_Category_BugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segnalazione bug`)
};

const nl_feedback_category_bug = /** @type {(inputs: Feedback_Category_BugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bugrapport`)
};

const pl_feedback_category_bug = /** @type {(inputs: Feedback_Category_BugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zgłoszenie błędu`)
};

const fi_feedback_category_bug = /** @type {(inputs: Feedback_Category_BugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virheraportti`)
};

const da_feedback_category_bug = /** @type {(inputs: Feedback_Category_BugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fejlrapport`)
};

const sv_feedback_category_bug = /** @type {(inputs: Feedback_Category_BugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Felrapport`)
};

/**
* | output |
* | --- |
* | "Bug Report" |
*
* @param {Feedback_Category_BugInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const feedback_category_bug = /** @type {((inputs?: Feedback_Category_BugInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Category_BugInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_feedback_category_bug(inputs)
	if (locale === "fr") return fr_feedback_category_bug(inputs)
	if (locale === "es") return es_feedback_category_bug(inputs)
	if (locale === "it") return it_feedback_category_bug(inputs)
	if (locale === "nl") return nl_feedback_category_bug(inputs)
	if (locale === "pl") return pl_feedback_category_bug(inputs)
	if (locale === "fi") return fi_feedback_category_bug(inputs)
	if (locale === "da") return da_feedback_category_bug(inputs)
	if (locale === "sv") return sv_feedback_category_bug(inputs)
	return en_feedback_category_bug(inputs)
});